import React from "react";
import { Box, Typography, Button } from "@mui/material";
import "./scheduleInspectionUI.scss";
import { useNavigate } from "react-router-dom";
import Schedule from "../../styles/svg/calendar-time.svg";

const ScheduleInspectionUI = () => {
  const redirect = useNavigate();
  return (
    <Box className="schedule-inspection-container">
      <Box className="schedule-inspection-content">
        <Box className="schedule-icon-wrapper">
          <img src={Schedule} alt="Schedule" className="schedule-icon" />
        </Box>
        <Typography variant="h6" className="schedule-title">
          Schedule your inspection
        </Typography>
      </Box>
      <Button 
        variant="contained" 
        className="schedule-button"
        onClick={() => redirect("/schedule-inspection")}
      >
        Schedule Inspection
      </Button>
    </Box>
  );
};

export default ScheduleInspectionUI; 